import { createInstance } from '@optimizely/optimizely-sdk';

export interface UserAttributes {
  [key: string]: number;
}

class OptimizelyClientService {
  private optimizely: any;

  public initialize(clientId: string) {
    this.optimizely = createInstance({
      sdkKey: clientId,
    });
  }
  // Ensure the client is initialized
  public async ensureClientReady(): Promise<void> {
    if (this.optimizely === null) {
      return;
    }
    await this.optimizely.onReady();
  }

  // Method to check if a feature is enabled
  public async isFeatureEnabled(featureKey: string, attributes?: UserAttributes): Promise<boolean> {
    try {
      await this.ensureClientReady();
      return (
        (this.optimizely !== null &&
          this.optimizely.isFeatureEnabled(featureKey, '', attributes)) ||
        false
      );
    } catch (error) {
      console.error('Error checking feature flag:', error);
      return false; // Return false in case of error
    }
  }
}

export default OptimizelyClientService;
